import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AgGridModule } from 'ag-grid-angular';
import { SharedModule } from '../../shared/shared.module';
import { LfsaBotonEditarGridComponent } from 'src/app/shared/components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component';

import { CalendarioComponent } from './views/calendario/calendario.component';
import { ComisionesRoutingModule } from './comisiones-routing.module';
import { TipoDeVendedorComponent } from './views/tipo-de-vendedor/tipo-de-vendedor.component';
import { AltaDeVendedoresComponent } from './views/alta-de-vendedores/alta-de-vendedores.component';
import { CumplimientoVsGananciaComponent } from './views/cumplimiento-vs-ganancia/cumplimiento-vs-ganancia.component';
import { CumplimientoVsGananciaCSVComponent } from './views/cumplimiento-vs-ganancia-upload-csv/cumplimiento-vs-ganancia-upload-csv.component';
import { ConfiguracionTiposVariablesIncentivosComponent } from './views/configuracion-tipos-variables-incentivos/configuracion-tipos-variables-incentivos.component';
import { AsignacionesComponent } from './views/asignaciones/asignaciones.component';
import { AsignacionDistribucionComponent } from './views/asignacion-y-distribucion/asignacion-y-distribucion.component';
import { AsignacionDistribucionCSVComponent } from './views/asignacion-y-distribucion-upload-csv/asignacion-y-distribucion-upload-csv.component';
import { AsignacionDistribucionIncentivosComponent } from './views/asignacion-y-distribucion-incentivos/asignacion-y-distribucion-incentivos.component';
import { AsignacionDistribucionIncentivosCSVComponent } from './views/asignacion-y-distribucion-incentivos-upload-csv/asignacion-y-distribucion-incentivos-upload-csv.component';
import { AsignacionCalendarioComponent } from './views/asignacion-de-calendarios/asignacion-de-calendarios.component';
import { CargaInicialPromediosComisionComponent } from './views/carga-inicial-promedios-comision/carga-inicial-promedios-comision.component';
import { CargaMetaIncentivoSellOutComponent } from './views/carga-meta-incentivo-sell-out/carga-meta-incentivo-sell-out.component';
import { ProcesamientoDeComisionesComponent } from './views/procesamiento-de-comisiones/procesamiento-de-comisiones.component';
import { HabilitarPeriodoDeComisionesComponent } from './views/habilitar-periodo-de-comisiones/habilitar-periodo-de-comisiones.component';
import { CarteraCargasUploadCsvComponent } from './views/cartera-cargas-upload-csv/cartera-cargas-upload-csv.component';
import { ReporteAvanceDeComisionesIndividualesComponent } from './views/reporte-avance-de-comisiones-individuales/reporte-avance-de-comisiones-individuales.component';
import { ReporteDeLiquidacionIndividualComponent } from './views/reporte-de-liquidacion-individual/reporte-de-liquidacion-individual.component';
import { VendedoresRelacionadosComponent } from './views/vendedores-relacionados/vendedores-relacionados.component';
import { ProcesamientoDeComisionesExcolaboradoresComponent } from './views/procesamiento-de-comisiones-excolaboradores/procesamiento-de-comisiones-excolaboradores.component';
import { ProcesamientoDeComisionesFondoVehicularComponent } from './views/procesamiento-de-comisiones-fondo-vehicular/procesamiento-de-comisiones-fondo-vehicular.component';
import { HabilitarPeriodoDeComisionesComponent2 } from './views/habilitar-periodo-de-comisiones2/habilitar-periodo-de-comisiones.component';

@NgModule({
    declarations: [
    CalendarioComponent,
    TipoDeVendedorComponent,
    AltaDeVendedoresComponent,
    CumplimientoVsGananciaComponent,
    CumplimientoVsGananciaCSVComponent,
    ConfiguracionTiposVariablesIncentivosComponent,
    AsignacionesComponent,
    AsignacionDistribucionComponent,
    AsignacionDistribucionCSVComponent,
    AsignacionDistribucionIncentivosComponent,
    AsignacionDistribucionIncentivosCSVComponent,
    AsignacionCalendarioComponent,
    CargaInicialPromediosComisionComponent,
    CargaMetaIncentivoSellOutComponent,
    ProcesamientoDeComisionesComponent,
    ProcesamientoDeComisionesExcolaboradoresComponent,
    ProcesamientoDeComisionesFondoVehicularComponent,
    HabilitarPeriodoDeComisionesComponent,
    HabilitarPeriodoDeComisionesComponent2,
    CarteraCargasUploadCsvComponent,
    ReporteAvanceDeComisionesIndividualesComponent,
    ReporteDeLiquidacionIndividualComponent,
    VendedoresRelacionadosComponent,
    ],
    exports: [
      
    ],
    imports: [
      CommonModule,
      ComisionesRoutingModule,
      RouterModule,
      FormsModule,
      ReactiveFormsModule,
      SharedModule,
      AgGridModule.withComponents([LfsaBotonEditarGridComponent]),
    ]
  })
export class ComisionesModule {}